const getCustomerCredit = state =>
  state.customer?.client_credit_balances_list ?? [];

export default getCustomerCredit;
